export default "__VITE_ASSET__698c9c20__"